import { gql } from '@apollo/client';

export const OPERATION_NAME = 'AuditLogDistinctActions';

export const DISTINCT_ACTIONS_QUERY = gql`
  query ${OPERATION_NAME}($where: org_audit_logs_bool_exp!) {
    org_audit_logs(where: $where, distinct_on: [action], order_by: [{ action: asc }]) {
      action
    }
  }
`;

export function buildVariables({ where }) {
  return { where };
}
